
/**
 * --- External Imports ---
 */
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

/**
 * --- Internal Imports ---
 */
import { GetCoordinatingGroupsByTrialId, GetCoordinatingGroupsByTrialIdResponse } from "@/apis/dtos";
import useGet from "../apis/useGet";

/**
 * --- Hook ---
 */
const getData = (response?: SWRResponse<GetCoordinatingGroupsByTrialIdResponse, GetCoordinatingGroupsByTrialIdResponse>) => response?.data?.coordinatingGroups;
const getError = (response?: SWRResponse<GetCoordinatingGroupsByTrialIdResponse, GetCoordinatingGroupsByTrialIdResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetCoordinatingGroupsByTrialIdResponse, GetCoordinatingGroupsByTrialIdResponse>) => ({});

const useGetTrialCoordinatingGroups = (query?: Partial<GetCoordinatingGroupsByTrialId>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetCoordinatingGroupsByTrialId(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetTrialCoordinatingGroups;